import React from "react";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";

// components
import Section from "src/components/Section";
import { Slider } from "./components";

// assets
import BackstageImg from "src/assets/images/error/error.png";

import styles from "./NotFound.module.scss";
import { SearchGradient } from "src/assets/icons";
const cx = classNames.bind(styles);

const NotFound = () => {
  return (
    <div>
      <Section>
        <div className={cx("not-found-root")}>
          <div className={cx("img-wrapper")}>
            <img src={BackstageImg} alt="..." />
          </div>
          <div className={cx("message")}>
            <h2>The page you were looking for doesn't exist.</h2>
            <p>The search below should help!</p>
          </div>
          <div className={cx("search-section")}>
            <div className={cx("search-wrapper")}>
              <SearchGradient />
              <input type="text" placeholder="Search anything...." />
              <button>Search</button>
            </div>
            <div className={cx("divider")}>
              <hr />
              <span>OR</span>
              <hr />
            </div>
            <div className={cx("btn-wrapper")}>
              <Link to="/">
                <button>Go to Homepage</button>
              </Link>
            </div>
          </div>
          <h2 className={cx("heading")}>More Interesting Events</h2>
        </div>
      </Section>
      <Slider />
    </div>
  );
};

export default NotFound;
